(function() {
    'use strict';

    angular.module( APP_ID )
        .component( 'subjectsListing', {
            bindings: {
                subjects: '<',
            },
            templateUrl: 'app/views/partials/content/subjects-listing.html',

            controller:   subjectsListingController,
            controllerAs: 'vm',

            renderingOptions: {
                'subject-listing': {
                    inputs:    [
                        'subjects="::customData.subjects"'
                    ],
                    parentClasses: [ 'subjects-listing' ]
                }
            }
        });


    /**
     * Renders all available subjects as a list of expandable/collapsible
     * panels.
     *
     * @param {ng.IScope} $scope
     * @param {uirouter.State} $state
     * @param {uirouter.UiRouterGlobals} $uiRouterGlobals
     * @param {MetaService} MetaService
     * @param {Utils} Utils
     * @param {Object} TEXTS
     * @param {Object} CONFIG
     */
    function subjectsListingController(
        $scope,
        $state,
        $uiRouterGlobals,
        MetaService,
        Utils,
        TEXTS,
        CONFIG
    ){

        /** @type {angular.IController} */
        var vm       = this;





        /* ===== PRIVATE MEMBERS ============================================ */


        /** @const */
        var EXAMPLE_COURSES_BLOCK_TYPE = 'course-examples';

        // Members
        var isInitialised = false;





        /* ===== EXPOSE TO THE SCOPE ======================================== */


        $scope._                = TEXTS;
        $scope.sharedContent    = Utils.getSharedContent();





        /* ===== EXPOSE TO THE CONTROLLER =================================== */


        // Methods
        vm.isExampleCoursesDynamicBlock = isExampleCoursesDynamicBlock;
        vm.initPanel                    = initPanel;
        vm.togglePanel                  = togglePanel;





        /* ===== RUN ON INSTANTIATION ======================================= */


        /** @constructor */
        //vm.$onInit = function() {};





        /* ===== PUBLIC METHODS ============================================= */


        /**
         * Inits expandable/collapsible panel for a given subject and decides
         * whether it should be opened or closed by default.
         *
         * @param {Object} subject
         */
        function initPanel( subject ) {
            if ( !isInitialised ) {
                initSubjectIdsFromUrl();
                isInitialised = true;
            }
            // Pre open panel if there's only single subject OR it should be opened because of the URL query selection
            subject.isOpened = containsSingleSubject() || isSubjectSelected( subject.asset_metadata_WebPath );

            // Last selected (opened) subject will get propagated into page's metadata (SEO)
            enhanceMetaInformation( subject );
        }


        /**
         * Toggles panel (opens/closes it) for a given subject.
         *
         * If there is more than a single subject on the page, it also
         * updates the URL queries so the view is shareable and trackable.
         *
         * @param {Object} subject
         */
        function togglePanel( subject ) {
            if ( !containsSingleSubject() ) {
                var newQueryList = toggleSubjectIdInSubjectQueries( subject.asset_metadata_WebPath );

                vm.subjects.selectedSubjectIds = newQueryList.slice();
                $state.go( '.', { subject: newQueryList }, { location: 'replace', notify: false } );
            }

            subject.isOpened = !subject.isOpened;

            // Last selected (opened) subject will get propagated into page's metadata (SEO)
            enhanceMetaInformation( subject );
        }


        //TODO: MUST be removed after its migrated to the dynamic blocks in the CMS.
        /**
         * @deprecated Use `dynamic block` feature instead of value hard-coded inside the template!
         *
         * @param {Object[]} dynamicBlocks
         * @returns {(void|boolean)}
         */
        function isExampleCoursesDynamicBlock( dynamicBlocks ) {
            if ( !dynamicBlocks ) return;

            return dynamicBlocks.some( function( block ) {
                return ( block.contentType === EXAMPLE_COURSES_BLOCK_TYPE );
            });
        }





        /* ===== PRIVATE FUNCTIONS ========================================== */


        function initSubjectIdsFromUrl() {
            // URL queries ~ selected subject(s)
            var subjectsParam = $uiRouterGlobals.params[ CONFIG.PARAMS.SUBJECT ];

            if ( subjectsParam ) {
                vm.subjects.selectedSubjectIds = angular.isArray( subjectsParam ) ? subjectsParam : new Array( subjectsParam );
            }
        }


        function enhanceMetaInformation( subjectObject ) {
            if ( !containsSingleSubject() ) {
                // Adjust Meta information
                if ( subjectObject.isOpened ) {
                    MetaService.updateTitleStructure( { suffix: subjectObject.asset_name } );
                }
            }
        }


        function toggleSubjectIdInSubjectQueries( subjectId ) {
            if ( !vm.subjects.selectedSubjectIds ) vm.subjects.selectedSubjectIds = [];

            var newQueriesList = [], subjectIdExists = false;

            vm.subjects.selectedSubjectIds.forEach( function( selectedSubjectId ) {
                if ( selectedSubjectId === subjectId ) {
                    subjectIdExists = true;
                } else {
                    newQueriesList.push( selectedSubjectId );
                }
            });

            if ( !subjectIdExists ) newQueriesList.push( subjectId );

            return newQueriesList;
        }


        function isSubjectSelected( subjectId ) {
            return ( vm.subjects.selectedSubjectIds && vm.subjects.selectedSubjectIds.indexOf( subjectId ) > -1 );
        }


        function containsSingleSubject() {
            return ( vm.subjects && vm.subjects.length === 1 );
        }
    }


    subjectsListingController.$inject = [ '$scope', '$state', '$uiRouterGlobals', 'MetaService', 'Utils', 'TEXTS', 'CONFIG' ];
})();
